import { SupabaseJob, Job } from '@applicator/shared'

import { supabase } from '../../../lib/supabase'

import { updateSupabaseJobsState, updateJobsStateForSelected } from './helpers'

// Helper function to handle realtime update payload
export function handleRealtimeUpdate(
  payload: { new: SupabaseJob; old: SupabaseJob },
  isMounted: boolean,
  selectedJobId: string | null,
  setSupabaseJobs: React.Dispatch<React.SetStateAction<SupabaseJob[]>>,
  setJobs: React.Dispatch<React.SetStateAction<Job[]>>,
  supabaseJobs: SupabaseJob[]
) {
  if (!isMounted) return
  console.log('[JOB DETAIL] 🔄 Update received:', payload.new)
  
  const updatedJob = payload.new as SupabaseJob
  
  // Update supabaseJobs with new data (relevance, dates, etc.)
  setSupabaseJobs((prev) => updateSupabaseJobsState(updatedJob, prev))
  
  // Update jobs state with formatted dates if this is the selected job
  if (updatedJob.id === selectedJobId) {
    setJobs((prev) => updateJobsStateForSelected(updatedJob, prev, supabaseJobs))
  }
}

// Helper function to cleanup channel
// Suppresses WebSocket errors that occur during cleanup when connection is already closed
export function cleanupChannel(ch: ReturnType<typeof supabase.channel> | null) {
  if (!ch) return
  
  // Check channel state before cleanup
  // Only cleanup if channel is not already closed or errored
  const channelState = (ch as { state?: string }).state
  const isAlreadyClosed = channelState === 'closed' || channelState === 'errored'
  
  // Unsubscribe first - this gracefully closes the channel
  try {
    if (typeof ch.unsubscribe === 'function' && !isAlreadyClosed) {
      ch.unsubscribe().catch(() => {
        // Silently ignore unsubscribe errors
      })
    }
  } catch (error) {
    // Silently ignore - channel might already be closed
  }
  
  // Remove channel from Supabase client
  // removeChannel returns a Promise, so we need to handle it properly
  if (supabase && typeof supabase.removeChannel === 'function' && !isAlreadyClosed) {
    // Suppress console errors for WebSocket cleanup
    // The error is thrown internally by Supabase before we can catch it
    // We use a try-catch around the promise to minimize console noise
    try {
      const removePromise = supabase.removeChannel(ch)
      if (removePromise && typeof removePromise.catch === 'function') {
        removePromise.catch(() => {
          // Silently ignore - expected when WebSocket is already closed
        })
      }
    } catch (error) {
      // Silently ignore synchronous errors
    }
  }
}
